import { useRef, useState } from 'react';
import classNames from 'classnames';

import MenuIcon from '@svg/menu.svg';
import SearchIcon from '@svg/search.svg';
import ArrowRightIcon from '@svg/arrows-right.svg';
import OutletLogo from '@svg/outlet-logo.svg';
import { useAppContext } from '@contexts/AppContext';
import { ShafaLogo } from '@ui/ShafaLogo';
import { Button } from '@ui/Button';
import { HeaderSearchContainer, RootCatalog } from '@containers/HeaderSearch';
import { HeaderFastLinks } from '@components/HeaderFastLinks';

import s from './HeaderMobile.sss';

interface FastLink {
  icon: React.FC<React.SVGProps<SVGAElement>>,
  counter?: number | null,
  indicator?: boolean,
  href?: string,
  onClick?: () => void,
}

interface Props {
  className?: string,
  rootCatalogs?: RootCatalog[],
  fastLinks: FastLink[],
  onOpenMenu: () => void,
}

export const HeaderMobile: React.FC<Props> = ({
  className,
  rootCatalogs,
  fastLinks,
  onOpenMenu,
}) => {
  const searchFormRef = useRef<HTMLFormElement>(null);
  const [isSearching, setIsSearching] = useState(false);

  const { isOutlet } = useAppContext();

  const onSearchClick = () => {
    if (isSearching) {
      searchFormRef.current!.submit();
    } else {
      setIsSearching(true);
    }
  };

  return (
    <div className={classNames(s.root, className)}>
      <div className={s.container}>
        {isSearching ? (
          <>
            <Button
              className={s.backButton}
              theme='text'
              onClick={() => setIsSearching(false)}
            >
              <ArrowRightIcon
                className={s.backIcon}
                width='24'
                height='24'
              />
            </Button>

            <HeaderSearchContainer
              className={s.search}
              rootCatalogs={rootCatalogs}
              isMobile={true}
            />
          </>
        ) : (
          <>
            <Button
              className={s.burgerButton}
              theme='text'
              onClick={(e) => {
                e.stopPropagation();
                onOpenMenu();
              }}
            >
              <MenuIcon
                className={s.butgerIcon}
                width='20'
                height='16'
              />
            </Button>

            <a
              href="/"
              className={s.logoLink}
            >
              {isOutlet ? (
                <OutletLogo
                  className={s.logo}
                  width="106"
                  height="32"
                />
              ) : (
                <ShafaLogo
                  className={s.logo}
                  width="72"
                  height="20"
                />
              )}
            </a>
          </>
        )}
      </div>

      {!isSearching && (
        <div className={s.fastLinks}>
          <HeaderFastLinks fastLinks={fastLinks} />

          <Button
            className={s.searchButton}
            theme='text'
            onClick={onSearchClick}
          >
            <SearchIcon
              className={s.searchIcon}
              width='24'
              height='24'
            />
          </Button>
        </div>
      )}
    </div>
  );
};
